import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
//import 'material-design-icons-iconfont/dist/material-design-icons.css'


import axios from 'axios'

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$axios = axios
// 다른 컴포넌트에서는 import 없이 this.$axios로 사용가능

Vue.config.productionTip = false

import * as VueGoogleMaps from "vue2-google-maps" // Import package

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyACG-ODysKQE3l-DkA_vydl2Y9g5HHnQxY",
    libraries: "places",
    //region: "KR", // 반드시 추가하셔야됩니다.(추가 안하시면 동해가 일본해로 나타납니다.)
     installComponents: true,
  }
});



Vue.use(vuetify)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
